module.exports = __webpack_public_path__ + "static/img/tnB_3.6ddcb9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/tnB_3.png
// module id = 1278
// module chunks = 1